/** Impls dos use cases do livro de registros. @since S5 */
import type {
  LivroRegistro, LivroRegistroItem, AbrirLivroRegistroCommand, AddLivroRegistroItemCommand,
} from '@/domain/model/LivroRegistro';
import type { LivroRegistroGateway } from '@/application/port/out/LivroRegistroGateway';
import type {
  ListLivrosRegistroUseCase, AbrirLivroRegistroUseCase, FecharLivroRegistroUseCase,
  ListLivroRegistroItensUseCase, AddLivroRegistroItemUseCase,
} from '@/application/port/in/LivroRegistroUseCase';

export class ListLivrosRegistro implements ListLivrosRegistroUseCase {
  constructor(private readonly g: LivroRegistroGateway) {}
  execute(educationLevelId?: string): Promise<LivroRegistro[]> { return this.g.list(educationLevelId); }
}
export class AbrirLivroRegistro implements AbrirLivroRegistroUseCase {
  constructor(private readonly g: LivroRegistroGateway) {}
  execute(cmd: AbrirLivroRegistroCommand): Promise<LivroRegistro> { return this.g.abrir(cmd); }
}
export class FecharLivroRegistro implements FecharLivroRegistroUseCase {
  constructor(private readonly g: LivroRegistroGateway) {}
  execute(id: string, termoFechamento: string | null): Promise<LivroRegistro> { return this.g.fechar(id, termoFechamento); }
}
export class ListLivroRegistroItens implements ListLivroRegistroItensUseCase {
  constructor(private readonly g: LivroRegistroGateway) {}
  execute(id: string): Promise<LivroRegistroItem[]> { return this.g.listItens(id); }
}
export class AddLivroRegistroItem implements AddLivroRegistroItemUseCase {
  constructor(private readonly g: LivroRegistroGateway) {}
  execute(id: string, cmd: AddLivroRegistroItemCommand): Promise<LivroRegistroItem> { return this.g.addItem(id, cmd); }
}
